import { Buffer } from "buffer";
// The shared crypto modules in src/crypto use Node's Buffer as a global.
// Installed before any import that could reach them, because a module that
// touches Buffer at evaluation time would otherwise fail on load rather than
// at the call site, where the message would at least point somewhere useful.
globalThis.Buffer = globalThis.Buffer ?? Buffer;

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode><App /></React.StrictMode>,
);
